import moment from 'moment';
import React from 'react';
import { Box, Button } from '@mui/material';
import { getMicroExperienceListForCustomer, deleteMicroExperienceForCustomer } from '../../../Services/Microexperiences'
import {
    DataGridPro,
} from '@mui/x-data-grid-pro';

export default function MicroExperienceList({ customerId, onSelectMX, onDeleteMX }) {
    const [mxList, setMXList] = React.useState([])
    React.useEffect(() => {
        async function getData() {
            const data = await getMicroExperienceListForCustomer(customerId) || [];
            const mxList = data.map(mx => {
                return {
                    ...mx, 
                    microContent : JSON.parse(mx.micro_content_cache || '{}'),
                    variation : JSON.parse(mx.micro_content_variation_cache),
            }});
            setMXList(mxList)
        }
        getData();
    }, [customerId])

    const getRowDate = (bookingDate) => {
        return bookingDate ? moment(bookingDate).format('DD MMM YYYY') : "";
    };

    const getCategory = (id) => {
        const mx = mxList.filter(mxid => mxid?.id === id)[0];
        return mx?.mx_type === "BUNDLE" ? mx.bundle_type : mx.customer_status;
    };

    function selectRow(row) {
        onSelectMX(row.row);
    }

    function deleteRow(row) {
        onDeleteMX('RELOAD_LIST');
        async function deleteData() {
            await deleteMicroExperienceForCustomer(row.id);
            onDeleteMX('LIST');
        }
        deleteData();
    }

    const columns = [
        {
            field: 'scheduled_date',
            headerName: 'Date',
            valueFormatter : params => getRowDate(params.value|| ''),            
            valueGetter: (params) => {
                return params.value ? moment(params.value) : "";
            },
            width: 100, 
        },
        {
            field: 'display_name',
            headerName: 'Name',
            width: 150, 
            editable: false,
        },
        {
            field: 'mx_type',
            headerName: 'Type',
            width: 150, 
            editable: false,
        },
        {
            field: 'bundle_type',
            headerName: 'Category',
            width: 100, 
            valueFormatter : params => getCategory(params.id|| ''),       
            editable: false,
        },
        {
            field: 'delivery_type',
            headerName: 'Delivery',
            width: 100, 
            editable: false,
        },
        {
            field: 'internal_status',
            headerName: 'Status',
            width: 100, 
            editable: false,
        },
        {
            field: 'internal_note',
            headerName: 'Note',
            width: 130, 
            editable: false,
        },  
        {
            field: 'customer_feedback',
            headerName: 'Feedback',
            width: 130, 
            editable: false,
        },          
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    deleteRow(params.row);
                };

                return (
                    <Button variant="contained" color="primary" onClick={onClick}>
                        Delete
                    </Button>
                );
            },
            
        },
    ];

    return (
        <Box sx={{ flex: 1 }}>
                <DataGridPro
                    rows={[...mxList].sort((a,b)=>b.created_on > a.created_on ? 1 : -1)}
                    columns={columns}
                    pagination={true}
                    pageSize={10}
                    onRowClick={selectRow}
                    sx={{
                        '.MuiDataGrid-columnHeaders': {
                            fontWeight: 'bold',
                            fontSize: 14,
                            color: 'rgb(0,0,0)',
                            backgroundColor: 'rgb(244,246,248)',
                        },
                        '.MuiTablePagination-selectLabel': {
                            marginBottom: '0px',
                        },
                        '.MuiTablePagination-displayedRows': {
                            marginBottom: '0px',
                        },
                        '.MuiPaper-root.div.span': {
                            color: 'blue',
                        },
                        '.MuiDataGrid-main': {
                            height: '576px',
                        }
                    }}
                />
            </Box>        
    );
}
